
import Cookie from 'js-cookie'
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Upload } from 'ant-design-vue'
import { uploadImgUrl } from '@/service/url'
import { UploadFile } from 'ant-design-vue/types/upload'
import { UPLOAD_LIMIT_SIZE } from '@/config'

const AUpload = {
  extends: Upload,
  methods: {
    reBeforeUpload(file: any, fileList: any) {
      const beforeUpload = (this as any).$props.beforeUpload;

      if (!beforeUpload) {
        return true;
      }
      const result = beforeUpload(file, fileList);
      if (result === false) {
        return false;
      }
      if (result && result.then) {
        return result;
      }
      return true;
    },
  }
}

@Component({
  inheritAttrs: false,
  components: { AUpload },
})
export default class PictureUpload extends Vue {
  @Prop({ default: uploadImgUrl }) action!: string
  @Prop({ default: 'files' }) name!: string
  @Prop({ default: 'image/jpeg,image/png' }) accept!: string

  /** 文件大小限制，单位kb */
  @Prop({ default: UPLOAD_LIMIT_SIZE * 1024 }) limitSize!: number
  @Prop() sizeExceedTip?: string
  /** 上传文件数限制 */
  @Prop({ default: 1 }) limit!: number
  @Prop({ default: '点击上传 '}) text!: string
  @Prop() value?: string | string[]

  fileList: Partial<UploadFile>[] = []
  previewVisible = false
  previewImage = ''
  headers = {
    'access-token': Cookie.get('accessToken'),
    'user-id': Cookie.get('userId')
  }

  get _sizeExceedTip() {
    if (this.sizeExceedTip) return this.sizeExceedTip
    const size = this.limitSize / 1024
    const ret = size >= 1 ? `${size}M` : `${this.limitSize}KB`
    return `单个文件大小不能超过${ret}`
  }

  get listeners() {
    const { change, ...listeners } = this.$listeners // eslint-disable-line
    return listeners
  }

  @Watch('value', { immediate: true })
  updateFileList(value?: string | string[]) {
    Array.isArray(value) || (value = [value as string].filter(Boolean))
    this.fileList = value.map(url => ({
      uid: url,
      url,
      thumbUrl: url,
      name: url,
    }))
  }

  beforeUpload(file: File) {
    if (file.size > this.limitSize * 1024) {
      this.$message.warning(this._sizeExceedTip)
      return false
    }
    if (!file.type || !this.accept.includes(file.type)) {
      this.$message.warning('不支持该文件类型，请重新选择')
      return false
    }
    const { beforeUpload } = this.$attrs
    if (beforeUpload) return (beforeUpload as any)(file)
  }

  onChange(info: any) {
    if (info.event) return this.$emit('progress', info)

    this.fileList = info.fileList
    if (info.file.status === 'uploading') {
      return this.$emit('start', info)
    }
    if (info.file.status === 'done') {
      const { code, msg, data } = info.file.response
      if ([9001, 9002].includes(code)) return this.$router.replace('/login')
      if (code === 0) {
        info.file.url = data.url
        info.file.thumbUrl = data.thumb_url
      } else {
        info.file.status = 'error'
        info.file.error = new Error(msg)
      }
      const i = this.fileList.findIndex(item => item.uid === info.file.uid)
      this.fileList.splice(i, 1, info.file)
    }
    if (info.file.status === 'error') {
      this.$message.error(`「${info.file.name}」上传失败`)
    }

    this.updateValue()
    this.$emit('change', info)
  }

  updateValue() {
    const nextValue = this.limit > 1
      ? this.fileList.map(file => file.url)
      : this.fileList[0]?.url || ''
    this.$emit('input', nextValue)
  }

  onPreview(file: any) {
    this.previewImage = file.url
    this.previewVisible = true
  }
}
